











































































































import CardHeader from "@/components/CardHeader.vue"

import {Component, Mixins} from "vue-property-decorator";
import {State} from "vuex-class";
import {BasicMixin} from "@/mixins/AdminMixin";
import {SoupLetterCategoryInterface} from "@/models/Games";

@Component({
    components:{
        CardHeader
    }
})
export default class SoupLetterCategory extends Mixins(BasicMixin) {
    @State(state => state.game.soupLettersCategories) categories: SoupLetterCategoryInterface[];


    public headers = [
        {
            text: 'Nombre',
            align: 'left',
            sortable: true,
            value: 'name',
        },
        {
            text: 'Palabras',
            align: 'left',
            sortable: true,
            value: 'words',
        },
        { text: 'Opciones', value: 'actions' },
    ];

    public category: SoupLetterCategoryInterface = {
        name: '',
        words:[],
    };

    public formAddData: any[] = [];
    public formAdd = '';

    removeAllElements(array: any[], elem: any) {
        let index = array.indexOf(elem);
        while (index > -1) {
            array.splice(index, 1);
            index = array.indexOf(elem);
        }
    }
    removeElement(array: any[], index: number) {
        array.splice(index, 1);
    }

    formSubmit(){
        this.category.words = this.formAddData;
        if (this.edit){
            this.$store.dispatch('editCollect', {id: this.idModel, data: this.category, collection: 'soupLettersCategories'});
            this.text = 'Se ha editado la categoria';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.$store.dispatch('createdSoupLetterCategory', this.category);
            this.text = 'Se ha creado el categoria';
            this.dialog = false;
            this.snackbar = true;
        }

    }

    openModal(edit: boolean, item: SoupLetterCategoryInterface | any) {
        this.edit = edit;
        this.dialog = true;
        if (edit) {
            this.idModel = item.id;
            this.formAddData = item.words;
            this.category = {
                name: item.name,
                words: item.words
            }
        } else {
            this.formAddData = [];
            this.category = {
                name: '',
                words: []
            }
        }
    }
    deleteItem(item: SoupLetterCategoryInterface){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'soupLettersCategories'})
    }

    addFormAdd(){
        this.formAddData.push(this.formAdd);
        this.formAdd = '';
    }
    removeCategory( index: number ) {
        this.removeElement(this.formAddData, index)
    }
}
